__turbopack_context__.v({
  "font": "font-editor-module-scss-module__NkCNeG__font",
});
